import { CATALOG } from "../../vault/catalog";
import { TypeIcon } from "../icons";
import { useT } from "../../i18n";

// Item-type picker for a new item: a tile grid instead of an 11-entry native <select> of emoji, so
// the choice is visible at a glance and one click away.
export function TypeGallery({ value, onChange }: { value: string; onChange: (type: string) => void }) {
  const t = useT();
  return (
    <div className="grid grid-cols-3 gap-1.5 sm:grid-cols-4">
      {CATALOG.map((tmpl) => {
        const active = tmpl.type === value;
        return (
          <button
            key={tmpl.type}
            type="button"
            onClick={() => onChange(tmpl.type)}
            aria-pressed={active}
            className={`flex items-center gap-1.5 rounded border px-2 py-1.5 text-left text-xs transition ${
              active ? "border-accent bg-accent/10 text-fg" : "border-border bg-panel2/40 text-muted hover:border-accent hover:text-fg"
            }`}
          >
            <TypeIcon type={tmpl.type} className="h-4 w-4 shrink-0" />
            <span className="truncate">{t(tmpl.label)}</span>
          </button>
        );
      })}
    </div>
  );
}
